import { useEffect, useRef } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { useAnalyticsClient } from '@/analytics/wac-analytics/analytics-client';

import { fireHoldoutExclusionAnalytics } from './jira-fy27h1-holdout-exclusion-analytics';

/**
 * Fires the `jiraFY27H1HoldoutExclusion triggered` track event once the tenant
 * ID has resolved, to populate the real-time TAP trait used for the Jira FY27H1
 * agentic-template holdout exclusion (new-site / provisioning flow).
 *
 * Callers are responsible for any feature-gating of
 * whether this is rendered at all.
 *
 * Sets the tenant on the shared analytics client immediately before firing so
 * the event carries it. This is idempotent — `<AnalyticsClientUpdater />` sets
 * the same value.
 *
 * Gated on a resolved `cloudId` so it never fires prematurely, and guarded with
 * a ref so it is emitted only once per tenant resolution.
 */
export const JiraFY27H1HoldoutExclusionTrigger = ({ cloudId }: { cloudId: string | undefined }) => {
	const analyticsClient = useAnalyticsClient();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const hasFired = useRef(false);

	useEffect(() => {
		if (!analyticsClient || !cloudId || hasFired.current) {
			return;
		}

		hasFired.current = true;

		fireHoldoutExclusionAnalytics({ analyticsClient, createAnalyticsEvent, cloudId });
	}, [analyticsClient, cloudId, createAnalyticsEvent]);

	return null;
};
